import { render, staticRenderFns } from "./docuAbout.vue?vue&type=template&id=364f6c21&scoped=true&"
import script from "./docuAbout.vue?vue&type=script&lang=js&"
export * from "./docuAbout.vue?vue&type=script&lang=js&"
import style0 from "./docuAbout.vue?vue&type=style&index=0&id=364f6c21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364f6c21",
  null
  
)

export default component.exports